import PlainList from './PlainList';

export default PlainList;
